import Loadable from '@/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const Triggers = Loadable(
  lazy(() => import('../pages/Triggers/index')),
  true,
)

const ClinicalTriggersRoutes: RouteObject = {
  path: 'gatilhos',
  children: [
    {
      path: ':clinicId',
      element: <Triggers />,
    },
  ],
}

export default ClinicalTriggersRoutes
